import styled from 'styled-components';
import colors from '@theme/colors';

export const Chip = styled.div`
  display: inline-block;
  color: ${colors.WHITE};
  background-color: ${colors.PRIMARY};
  border-radius: 2px;
  border-color: ${colors.PRIMARY};
  padding: 1px 10px 1px 10px;
  font-size: 12px;
  font-weight: 400;
  cursor: default;
  margin-right: 5px;
  line-height: 20px;
`;



// WEBPACK FOOTER //
// ./components/atoms/Chip.js